import script from "./BankAccountSuccessPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankAccountSuccessPage.vue?vue&type=script&setup=true&lang=ts"

import "./BankAccountSuccessPage.vue?vue&type=style&index=0&id=1f2ddae9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2ddae9"]])

export default __exports__